import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { route } from '../route/Index';
import Span from '../shared/component/Span';
import variable from '../shared/style/variable';
import vars from '../shared/variable';
import { cleanImage } from '../store/Image/imageSlice';
import { cleanAlert } from '../store/alert/alertSlice';
import { useAppDispatch } from '../store/hook';
import { cleanProject } from '../store/project/projectSlice';
import { cleanResult } from '../store/result/resultSlice';
import logoMaccaferri from './LogoMaccaferri.svg';
import gabioDrainDesignNegativo from './GabioDrainDesignNegativo.png';

interface IHeaderProps {}

const ButtonHub = styled(Button)`
    border: 0.1rem solid white;
    border-radius: 0.5rem;
    color: ${variable.white};
`;

const Header = (props: IHeaderProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const navigateToHome = () => {
        dispatch(cleanProject());
        dispatch(cleanResult());
        dispatch(cleanImage());
        dispatch(cleanAlert());
        navigate(route.home);
    };

    return (
        <Stack variant='header' justifyContent='space-between' alignItems='center'>
            <Stack color={variable.white} padding={'0 1rem'} height='100%' width='100%' direction='row' justifyContent='space-between' alignItems='center'>
                <Stack direction='row' alignItems='center' spacing={5}>
                    <Stack>
                        <img style={{ cursor: 'pointer' }} width={250} src={gabioDrainDesignNegativo} alt='logo-app-maccaferri' onClick={navigateToHome} />
                    </Stack>
                    <ButtonHub startIcon={<DeviceHubIcon />} onClick={() => (window.location.href = vars.URL_EDESIGN_PORTAL)}>
                        <Span text={t('backToHub')} />
                    </ButtonHub>
                </Stack>
                <Stack sx={{ display: { xs: 'none', sm: 'flex' } }}>
                    <img width={150} style={{ border: `2px solid ${variable.white}` }} src={logoMaccaferri} alt='logo-maccaferri' />
                </Stack>
            </Stack>
            <Stack variant='line' />
        </Stack>
    );
};

export default Header;
